export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const CHECK_AUTH = 'checkAuth'
export const LOGIN_CLIENT = 'loginClient'
export const LOGOUT_CLIENT = 'logoutClient'
export const CHECK_AUTH_CLIENT = 'checkAuthClient'
export const SET_OPEN_LOGIN_DIALOG = 'setOpenLoginDialog'
export const SET_OPEN_REGISTER_DIALOG = 'setOpenRegisterDialog'
export const HANDLE_MEMBER_NEW_MESSAGE_NOTIFICATION = 'handleMemberNewMessageNotification'
export const HANDLE_ADMIN_CONVERSATION_NEW_MESSAGE = 'handleAdminConversationNewMessage'
export const HANDLE_HIDDEN_NAV_MENU = 'handleHiddenNavMenu'
export const SET_PREVIEW_FILE = 'setPreviewFile'
export const DESTROY_PREVIEW_FILE = 'destroyPreviewFile'
export const HANDLE_HIDDEN_REGISTER_HEADER = 'handleHiddenRegisterHeader'
